export default [{
  path: '/activityRegistration/reportList',
  name: 'reportList',
  meta: {
    title: '活动报名单'
  },
  component: () =>
      import( /* webpackChunkName: "pop-reportList" */ '../views/activityReportList/list.vue')
},
{
  path: '/activityRegistration/billDetails',
  name: 'billDetails',
  meta: {
    title: '账单明细'
  },
  component: () =>
    import( /* webpackChunkName: "pop-billDetails" */ '../views/activityReportList/billDetails.vue')
}
]